import { useState, useMemo, useRef, useEffect } from 'react';
import { withTitle, components } from '@blaze-cms/react-page-builder';
import { FORM_SCHEMAS, INVALID_ACCESS_CODE_MESSAGE } from './constants';

// TODO: Move helpers to a shared location
import { getFormFields, getInitFormState } from '../ContactForm/helpers';
import FormInput from '../../blaze-plugins/shopware-fe-kp/components/FormInput';
import { validateForm } from '../../blaze-plugins/shopware-fe-kp/components/helpers';

const AccessCode = ({ children, restrictedMessage, accessCode, parent }) => {
  const formRef = useRef(null);

  const activeSchema = useMemo(() => FORM_SCHEMAS, []);
  const initialFormState = useMemo(() => getInitFormState(activeSchema), [activeSchema]);

  const [formValues, setFormValues] = useState(initialFormState);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    const savedCode = localStorage.getItem(`access_code-${parent.itemId}-${accessCode}`);
    if (savedCode) {
      setHasSubmitted(true);
      setShowSuccessMessage(true);
    }
  }, [accessCode, parent.itemId]);

  const handleValueChange = (key, value) => {
    setFormValues(prev => ({
      ...prev,
      [key]: {
        ...prev[key],
        value,
        error: false
      }
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();

    const [isValid, validatedForm] = validateForm(formValues, activeSchema);

    if (!isValid) {
      setFormValues(validatedForm);
      return;
    }

    const enteredCode =
      Object.values(formValues).find(field => field.fieldId === 'accessCode')?.value ||
      formValues.accessCode?.value;

    if (enteredCode === accessCode) {
      localStorage.setItem(`access_code-${parent.itemId}-${accessCode}`, 'true');
      setHasSubmitted(true);
      setShowSuccessMessage(true);
    } else {
      setFormValues(prev => ({
        ...prev,
        accessCode: {
          ...prev.accessCode,
          error: true,
          validationMessage: INVALID_ACCESS_CODE_MESSAGE
        }
      }));
    }
  };

  const fields = getFormFields(activeSchema);

  if (hasSubmitted && showSuccessMessage) {
    return children;
  }

  const { textblock: TextBlock } = components;

  return (
    <div className="access-code">
      <form ref={formRef} className="contact-form-container__form" onSubmit={handleSubmit}>
        <TextBlock html={restrictedMessage} />

        {fields.map(field => {
          if (!field.showInForm) return null;
          if (!formValues[field.fieldId]) return null;
          return (
            <FormInput
              key={field.fieldId}
              id={field.fieldId}
              className={field.fieldId}
              label={field.label}
              type={field.formFieldType}
              data={formValues[field.fieldId]}
              isRequired={field.isRequired}
              onChange={handleValueChange}
              options={field.options}
            />
          );
        })}

        <button type="submit" className="access-code__form__submit-button">
          Submit
        </button>
      </form>
    </div>
  );
};

export default withTitle(AccessCode);
